import { FC } from 'react'
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { observer } from 'mobx-react'
import { useTranslation } from 'next-i18next'
import { useStores } from '@/utils'
import { TextAreaGroup } from '@components/molecules/TextAreaGroup'
import { SettingButton } from '@components/atoms/SettingButton'
import { IAnswerBase, MessageType } from '@/types'
import styles from './index.module.scss'

type Props = {
  slug: string
  replies: IAnswerBase[]
  setReplies: (replies: IAnswerBase[]) => void
  isModalOpen?: boolean
  setIsModalOpen?: (isModalOpen: boolean) => void
}

type Value = {
  body: string
}

export const AddReplyForm: FC<Props> = observer(({ slug, replies, setReplies, isModalOpen, setIsModalOpen }) => {
  const { t } = useTranslation(['p', 'validation'])
  const { messages, viewer } = useStores()
  const initialValue: Value = {
    body: '',
  }

  const validationSchema = Yup.object().shape({
    body: Yup.string().required(t('validation:必須項目です')),
  })

  return (
    <div className={styles.container}>
      <Formik
        initialValues={initialValue}
        validationSchema={validationSchema}
        onSubmit={async (values: Value, actions) => {
          const output = await viewer.viewer?.addMyReply(slug, values.body)
          actions.setSubmitting(false)
          if (output.isSuccessful) {
            setReplies(replies.concat(output.data.reply))
            messages.add({
              type: MessageType.Info,
              body: 'Your reply posted.',
              isTranslated: true,
              ttl: 5000,
            })
          }
          actions.resetForm()
          setIsModalOpen(!isModalOpen)
        }}
      >
        {({ isSubmitting }) => {
          return (
            <Form>
              <div className={styles.textarea}>
                <Field name='body' placeholder='Your Reply' fieldType='baseColor' isSmall component={TextAreaGroup} />
              </div>
              <div className={styles.buttonContainer}>
                <SettingButton
                  isLoading={isSubmitting}
                  disabled={isSubmitting}
                  color='aqa'
                  buttonType='submit'
                  buttonSize='medium'
                >
                  Reply
                </SettingButton>
              </div>
            </Form>
          )
        }}
      </Formik>
    </div>
  )
})
